/**
 * Created by AlexanderC on Fri Jul 01 2016.
 */

/*eslint no-loop-func: 0, no-bitwise: 0, eqeqeq: 0 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let UUID = exports.UUID = function () {
  function UUID() {
    _classCallCheck(this, UUID);
  }

  _createClass(UUID, null, [{
    key: 'generate',

    /**
     * Generates an RFC4122 v4 compliant UUID
     *
     * If ensureUnique=true it ensures
     * an unique UUID across the current runtime
     *
     * IMPORTANT! This solution is not crypto-secure!
     *
     * @param {Boolean} ensureUnique = true
     * @returns {String}
     */
    value: function generate() {
      let ensureUnique = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this._uuids = this._uuids || [];

      let date = new Date().getTime();

      if (window && window.performance && typeof window.performance.now === 'function') {

        date += performance.now();
      }

      let uuid = null;

      do {
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
          date = Math.floor(date / 16);
          let rand = (date + Math.random() * 16) % 16 | 0;

          return (char == 'x' ? rand : rand & 0x3 | 0x8).toString(16);
        });
      } while (!ensureUnique || this._uuids.indexOf(uuid) !== -1);

      if (this._uuids.indexOf(uuid) === -1) {
        this._uuids.push(uuid);
      }

      return uuid;
    }
  }]);

  return UUID;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Driver/Kinesis/UUID.js
// module id = 384
// module chunks = 0